
import { AccountCircle, ChevronRight, Menu as MenuIcon, ExitToApp } from "@mui/icons-material"
import { AppBar as MuiAppBar, Box, Stack, IconButton, Link, Menu, MenuItem, Toolbar, Typography, styled } from "@mui/material"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link as RouterLink, useNavigate } from "react-router-dom"
import routes from "../components/routes"
import useMenu from "../hooks/useMenu"
import { logout } from "../redux/userSlice"
import { getInitials } from "../utils"
import { drawerWidth, navbarHeight } from "../theme"
import useIsSmallScreen from "../hooks/useIsSmallScreen"
import HashLinkScroll from "../components/HashLinkScroll"


const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));


const Navbar = ({ open, onOpen, AppBarComponent = AppBar, showDrawerMenu }) => {

    const userInfo = useSelector(x => x.user.userInfo)

    const { anchorEl, open: menuIsOpen, handleDefaultMenuClick, handleMenuClose } = useMenu()

    const dispatch = useDispatch()

    const handleLogout = () => { dispatch(logout()) }

    const navigate = useNavigate()

    const isSmallScreen = useIsSmallScreen();

    const [adaptiveMenuIsOpen, toggleAdaptiveMenu] = React.useState(false);

    const handleNavigateToLessons = () => {
        navigate(userInfo?.role?.name === "учитель" ? routes.lessonLogBook.path : routes.studentLessons.path)
    }

    return <AppBarComponent color="secondary" open={open} position="fixed" sx={{ borderRadius: 0, height: navbarHeight }}>

        <HashLinkScroll />

        <Toolbar color="secondary" sx={{ height: navbarHeight }}>

            {showDrawerMenu && <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={onOpen}
                edge="start"
                sx={{
                    mr: 5,
                    ...(open && { display: 'none' }),
                }}
            >
                <ChevronRight color='inherit' />
            </IconButton>}

            {!isSmallScreen &&
                <Link color="inherit" component={RouterLink} to="/" sx={{ textDecoration: "none" }}>
                    <Typography sx={{
                        letterSpacing: "4px",
                        fontSize: "24px"
                    }}>
                        ШКИ
                    </Typography>
                </Link>}

            <Stack sx={{
                position: { xs: "absolute", sm: "static" },
                top: { xs: "60px", sm: "0" },
                left: "0px",
                width: "100%",
                background: { xs: "black" },
                justifyContent: { xs: "flex-start", sm: "center" },
                paddingTop: { xs: "10px", sm: "0" },
                paddingBottom: { xs: "20px", sm: "0" },
                alignItems: "center",

            }}

                onClick={() => toggleAdaptiveMenu(false)}
                spacing={4}
                display={!isSmallScreen || adaptiveMenuIsOpen ? '' : 'none'}
                direction={{ xs: "column", sm: "row" }}
                component='div'
            >

                <Link color="inherit" sx={{ textDecoration: "none" }} component={RouterLink} to="/#studios">
                    Студии
                </Link>
                <Link color="inherit" sx={{ textDecoration: "none" }} component={RouterLink} to="/#news">
                    Новости
                </Link>
                <Link color="inherit" sx={{ textDecoration: "none" }} component={RouterLink} to="/#gallery">
                    Галерея
                </Link>

            </Stack>

            <IconButton onClick={() => toggleAdaptiveMenu(!adaptiveMenuIsOpen)}
                sx={{ display: { sm: "none" } }}
                size='large' color='inherit'>

                <MenuIcon />
            </IconButton>

            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", ml: "auto", width: 150 }} >
                {userInfo ? (
                    <>
                        <Typography noWrap>
                            {userInfo.surname} {getInitials([userInfo.name, userInfo.patronymic])}
                        </Typography>

                        <IconButton
                            aria-label="profile"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleDefaultMenuClick}
                            color="inherit"
                        >
                            <AccountCircle fontSize="large" />
                        </IconButton>

                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            open={menuIsOpen}
                            onClose={handleMenuClose}
                        >
                            <MenuItem onClick={handleNavigateToLessons}>
                                Личный кабинет
                            </MenuItem>
                            <MenuItem sx={{ color: "error.main" }} onClick={handleLogout}>
                                Выйти
                            </MenuItem>
                        </Menu>

                    </>
                ) : (
                    <Link color="inherit" sx={{ ml: "3px", textDecoration: "none" }} component={RouterLink} to={routes.login.path}>
                        <Stack direction="row">
                            <ExitToApp />
                            <Typography ml={1}>Войти</Typography>
                        </Stack>
                    </Link>
                )}
            </Box>
        </Toolbar>

    </AppBarComponent>
}

export default Navbar